import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiService } from '../shared/base-api.service';
import { HelpersService } from '../shared/helper.service';
import { ProgressBarService } from '../shared/progress-bar.service';
import { Proposal } from './proposal';
import { ProposalStatus } from './proposal-status';

@Injectable({
  providedIn: 'root'
})
export class ProposalStatusService extends BaseApiService<ProposalStatus> {

  constructor(
    public http: HttpClient,
    public helper: HelpersService,
    public loading: ProgressBarService
  ) {
    super(http, helper, loading);
    this.endpoint = 'proposal-statuses';
    this.query = { limit: 0, page: 0 };
  }

}
